import { render } from "./Coupons.vue?vue&type=template&id=17bb2cf5&scoped=true&ts=true"
import script from "./Coupons.vue?vue&type=script&lang=ts"
export * from "./Coupons.vue?vue&type=script&lang=ts"

import "./Coupons.vue?vue&type=style&index=0&id=17bb2cf5&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bb2cf5"]])

export default __exports__